/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, OnInit } from '@angular/core';
import { Constants } from '../../common/constants';

@Component({
  selector: 'app-fetch-data',
  templateUrl: './fetch-data.component.html',
  standalone: false,
})
export class FetchDataComponent implements OnInit {
  selectedItem: any;
  selectedGlyph: any;
  glyphslist: any;
  optionGrouplist: any;
  itemSelected: any;
  dividerlist: any;
  itemSelectedd: any;
  list: any;
  multiSelectList: any;
  radioList: any;
  selectedRadio: any;
  selectedInvalid: any;
  serviceSetting: any;

  ngOnInit(): void {
    this.list = Constants.languages;

    this.selectedItem = this.list[3];

    this.glyphslist = [
      {
        value: 'Personal',
        SDE_KEY: 'Personal',
        glyph: 'xgl-user',
      },
      {
        value: 'Business',
        SDE_KEY: 'Business',
        glyph: 'xgl-business',
      },
      {
        value: 'Other',
        SDE_KEY: 'Other',
        glyph: 'xgl-help',
      },
      {
        value: 'Data',
        SDE_KEY: 'Data',
        glyph: 'xgl-cloud',
      },
    ];

    this.selectedGlyph = this.glyphslist[0];

    this.optionGrouplist = [
      {
        title: 'Office Solutions',
        options: [
          {
            value: 'WorkCentre 3655',
            SDE_KEY: 'WorkCentre 3655',
          },
          {
            value: 'WorkCentre 6655',
            SDE_KEY: 'WorkCentre 6655',
          },
          {
            value: 'WorkCentre 7970',
            SDE_KEY: 'WorkCentre 7970',
          },
        ],
      },
      {
        title: 'Production Solutions',
        options: [
          {
            value: 'Xerox Nuvera 200',
            SDE_KEY: 'Xerox Nuvera 200',
          },
          {
            value: 'Xerox CiPress 500',
            SDE_KEY: 'Xerox CiPress 500',
          },
          {
            value: 'Xerox Rialto 900',
            SDE_KEY: 'Xerox Rialto 900',
          },
        ],
      },
    ];

    this.itemSelected = this.optionGrouplist[0].options[0];

    this.dividerlist = [
      {
        options: [
          {
            value: 'WorkCentre 3655',
            SDE_KEY: 'WorkCentre 3655',
          },
          {
            value: 'WorkCentre 6655',
            SDE_KEY: 'WorkCentre 6655',
          },
          {
            value: 'WorkCentre 7970',
            SDE_KEY: 'WorkCentre 7970',
          },
        ],
      },
      {
        options: [
          {
            value: 'Xerox Nuvera 200',
            SDE_KEY: 'Xerox Nuvera 200',
          },
          {
            value: 'Xerox CiPress 500',
            SDE_KEY: 'Xerox CiPress 500',
          },
          {
            value: 'Xerox Rialto 900',
            SDE_KEY: 'Xerox Rialto 900',
          },
        ],
      },
    ];

    this.itemSelectedd = this.dividerlist[0].options[0];

    this.multiSelectList = [
      {
        value: 'Item 1',
        SDE_KEY: 'Item 1',
        checked: false,
      },
      {
        value: 'Item 2',
        SDE_KEY: 'Item 2',
        checked: false,
      },
      {
        value: 'Item 3',
        SDE_KEY: 'Item 3',
        checked: false,
      },
      {
        value: 'Item 4',
        SDE_KEY: 'Item 4',
        checked: false,
      },
    ];

    this.radioList = [
      {
        value: 'Positive',
      },
      {
        value: 'Negative',
      },
      {
        value: 'Neutral',
      },
    ];

    this.selectedRadio = this.radioList[0];
  }

  update() {
    this.glyphslist.push({
      value: 'Settings',
      SDE_KEY: 'Settings',
      glyph: 'xgl-gear',
    });
    this.optionGrouplist.push({
      title: 'Newly added Solutions',
      options: [
        {
          value: 'AltaLink B8045',
          SDE_KEY: 'AltaLink B8045',
        },
        {
          value: 'AltaLink B8055',
          SDE_KEY: 'AltaLink B8055',
        },
        {
          value: 'AltaLink B8065',
          SDE_KEY: 'AltaLink B8065',
        },
      ],
    });
    this.dividerlist.push({
      options: [
        {
          value: 'AltaLink B8045',
          SDE_KEY: 'AltaLink B8045',
        },
        {
          value: 'AltaLink B8055',
          SDE_KEY: 'AltaLink B8055',
        },
        {
          value: 'AltaLink B8065',
          SDE_KEY: 'AltaLink B8065',
        },
      ],
    });
    this.multiSelectList.push({
      value: 'Item 5',
      SDE_KEY: 'Item 5',
      checked: true,
    });
    this.radioList.push({ value: 'Extreme' });
  }

  listChange(item: any) {
    console.log(`multi select list change ${item.value}`);
  }
}
